// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* モーダルのスタイル */
.modal.is-active {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

/* 必要に応じてBulmaを補完する最低限のスタイル */
.modal-card {
  width: 100%;
  max-width: 640px;
  margin: 0 20px;
}
`, "",{"version":3,"sources":["webpack://./packages/aiand-scenario/frontend/src/pages/admin/project/prompt/list/style.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* モーダルのスタイル */\n.modal.is-active {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n/* 必要に応じてBulmaを補完する最低限のスタイル */\n.modal-card {\n  width: 100%;\n  max-width: 640px;\n  margin: 0 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
